import type { JSX } from 'react';

import Emphasis from 'DesignSystem3/Text/Emphasis';
import { toMoneyWithSign } from 'utils/caseing';

interface ROIPillProps {
    totalReturnInDollars?: number;
    onClick?: () => void;
}

const ROIPill = ({ totalReturnInDollars, onClick }: ROIPillProps): JSX.Element => {
    const returnInDollars = totalReturnInDollars ?? 0;
    return (
        <div className="flex rounded-x20 bg-surface-x10">
            <div
                className={`flex items-center h-3 gap-0.5 rounded-x20 px-1 cursor-pointer flex-nowrap whitespace-nowrap ${
                    returnInDollars > 0 ? 'bg-brand-primary text-text-black' : 'bg-red-x20 text-red-x10'
                }`}
                onClick={onClick}
            >
                <Emphasis.x30>ROI</Emphasis.x30>
                <Emphasis.x30>{toMoneyWithSign(returnInDollars, false, Math.abs(returnInDollars) < 1000)}</Emphasis.x30>
            </div>
        </div>
    );
};

export default ROIPill;
